module.exports = __webpack_public_path__ + "img/sidebar_logout.02357431.svg";